import { Component, OnInit } from '@angular/core';
import { mywalletstore } from '../../../_services/mywallet/store/mywallet.store.service';
import { utilityService } from '../../../sharedcomponents/commonservice/utility.service';
import { Router, CanActivate } from '@angular/router';

@Component({
  selector: 'app-payment-receipt-store',
  templateUrl: './payment-receipt-store.component.html',
  styleUrls: ['./payment-receipt-store.component.css']
})
export class PaymentReceiptStoreComponent implements OnInit {
  storeList: any = [];
  cartcode=0;
  constructor(private storeservice: mywalletstore,
    private router: Router,
    public utilityServ: utilityService,) { }

  ngOnInit() {
     this.storeservice.getStoreInforeceiptData().subscribe(data => {

      this.storeList = this.utilityServ.getArray(data);
      this.cartcode = this.utilityServ.getObjectText(this.storeList[0].cartcode);

    });
  }
  agentLocator(){
    this.router.navigate(['/PaymentReceiptStore']);
    return;
  }

}



// WEBPACK FOOTER //
// ./src/app/dash-board/shoppingcart/payment-receipt-store/payment-receipt-store.component.ts